import { get, post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";
import WebEvaluation2SaveRequest from "../form/request/WebEvaluation2SaveRequest";

const API_PREFIX = "/webEvaluation2";

export const init = async request => {
  const param = `?listId=${request.listId}&termId=${request.termId}&serialNumber=${request.serialNumber}`;

  const response = await get(`${API_PREFIX}/${param}`, authHeader());
  console.log("response", response);
  return response.data;
};

export const save = async request => {
  const response = await post(`${API_PREFIX}/save`, new WebEvaluation2SaveRequest(request), authHeader());
  console.log("response", response);
  return response.data;
};
